<template>
  <b-modal ref="modal" lazy no-close-on-esc hide-header-close no-close-on-backdrop :hide-header="true"
    :hide-footer="true">
    <button @click="hide" type="button" aria-label="Close" class="close">×</button>

    <div class="modify-package-modal">
      <p style="font-weight: bold; text-align: center;">{{ title }}</p>

      <p style="font-size: 13px;">
        Important: The maximum number of records for this feature is 125 records totaling to 250 labels. &nbsp;If you
        selected more, we would only process the first 125 and leave the rest on the Ready page.
      </p>

      <b-card>
        <div class="card-header blue">
          <b-row>
            <b-col>Package Details</b-col>
          </b-row>
        </div>
        <div class="card-body">
          <b-form-row>
            <b-col>
              <b-form-group>
                <!-- service class options -->
                <b-select :options="serviceOptions" v-model="selectedService" :class="['form-control', 'custom-dropdown']"
                  name="service" @change="onServiceClassChange">
                  <template slot="first">
                    <option :value="''">Service Class (Same as Outbound)</option>
                  </template>
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group>
                <!-- package options -->
                <b-select :options="packageOptions" :class="['form-control', 'custom-dropdown']"
                  :disabled="!selectedService" v-model="selectedPackage" name="package" @change="clear(false)">
                  <template slot="first">
                    <option :value="''">Package Type (Same as Outbound)</option>
                  </template>
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <!-- WEIGHT -->
            <b-col sm="2" lg="1">
              <label class="p-1">
                <b-img src="/images/icons/wgt-sm.png" width="25" v-b-tooltip.hover title="Weight" />
              </label>
            </b-col>
            <b-col sm="5" lg="2">
              <b-form-group>
                <b-form-input type="number" placeholder="LB" :class="['form-control']" v-model="weight.lb"
                  :disabled="noLB" @change="clear(false)"></b-form-input>
                <!-- :class="['form-control', {'is-invalid': !noLB}]" -->
              </b-form-group>
            </b-col>
            <b-col sm="5" lg="2">
              <b-form-group>
                <input type="number" placeholder="OZ" :class="['form-control']" v-model="weight.oz"
                  @change="clear(false)" />
              </b-form-group>
            </b-col>
            <b-col sm="2" lg="1">
              <label class="pull-right p-1">
                <b-img src="/images/icons/dim-sm.png" width="25" v-b-tooltip.hover title="Dimensions" />
              </label>
            </b-col>
            <!-- DIMENSION -->
            <b-col sm="3" lg="2">
              <b-form-group>
                <input :disabled="isDimAllowed" type="number"
                  :class="['form-control', { 'is-invalid': !checkDimensions }]" placeholder="L" v-model="dimension.l"
                  @change="clear(false)" />
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2">
              <b-form-group>
                <input :disabled="isDimAllowed" type="number"
                  :class="['form-control', { 'is-invalid': !checkDimensions }]" placeholder="W" v-model="dimension.w"
                  @change="clear(false)" />
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2">
              <b-form-group>
                <input :disabled="isDimAllowed || selectedPackage === 'SOFTPACK'" type="number"
                  :class="['form-control', { 'is-invalid': !checkDimensions }]" placeholder="H" v-model="dimension.h"
                  @change="clear(false)" />
              </b-form-group>
            </b-col>
          </b-form-row>
        </div>
      </b-card>

      <!-- <b-row class="justify-content-center mb-3 text-danger" v-if="insufficient" style="font-size: 13px;"> -->
      <b-row
        :class='{ "justify-content-center": true, "mb-3": true, "text-danger": (insufficient || invalidServiceClass) }'
        style="font-size: 13px;">
        <span v-if="insufficient">
          <strong>Insufficient Funds. &nbsp;Please add more funds and try again.</strong>
          <br />
        </span>
        <span v-if="invalidServiceClass">
          <strong>Can't generate return label, service class or type may not be compatible.</strong>
          <br /></span>
        {{ ids.length }}
        Records Selected
        (Total Cost: ${{ totalRate.toFixed(2) }})
        (Total Insurance Cost: ${{ totalInsurance }})
      </b-row>

      <b-row class="justify-content-between">
        <b-col sm="auto">
          <b-btn class="btn-light-blue-outline" size="sm" @click="clearAll">
            Clear All Fields
          </b-btn>
        </b-col>
        <b-col sm="auto">
          <b-btn v-if="showContinue" class="btn-blue" size="sm" @click="save" :disabled="!allGood">
            Continue <span class="glyphicon glyphicon-arrow-right"></span>
          </b-btn>
          <b-btn v-else class="btn-blue" size="sm" @click="calculateCost" :disabled="calculating">
            <span v-if="calculating">Calculating ...</span>
            <span v-else> Calculate Cost</span>
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<style lang="scss">
.modify-package-modal {
  .card {
    font-size: 0.75rem;

    .card-header {
      font-size: 0.95rem;
      padding: 0.10rem 1rem;

      .btn {
        padding: 1px 8px;
      }
    }

    .form-group {
      margin-bottom: 0.5rem;
    }

    input,
    select,
    button,
    label,
    .input-group-text {
      font-size: 0.75rem;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .dropdown {
      .dropdown-toggle {
        padding: 2px;
      }
    }
  }
}
</style>

<script>
import DatePicker from "vue-bootstrap-datetimepicker";

import { mapGetters } from "vuex";
import moment from "moment";
import insurance from "../../data/insurance";
import _ from "lodash";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      title: 'Prepaid Return Label Details',
      allGood: false,
      showContinue: false,
      calculating: false,
      initialRate: 0,
      initialInsurance: 0,
      totalRate: 0,
      totalInsurance: 0,
      selectedService: '',
      selectedPackage: null,
      tmpMyPkg: '0x0x0',
      weight: { lb: null, oz: null },
      dimension: { l: null, w: null, h: null },

      ids: [],
      noLB: false,

      insufficient: false,
      invalidServiceClass: false,
    }
  },

  computed: {
    ...mapGetters({
      user: "getUser",
      balance: "getUserBalance",
      getCarrierRules: "getCarrierRules",
      getInsuranceCarrierRules: "getInsuranceCarrierRules",
      getShippingService: "getShippingService",
      shipping_services: "getShippingServices",
      products: "products",
      shipsurance: "getShipsurance",
    }),

    checkDimensions() {
      const { h, w, l } = this.dimension;

      const hasAll = h && w && l;
      if (this.selectedPackage === "SOFTPACK") {
        this.dimension.h = 1
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(h), parseInt(w), parseInt(l)];
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)

        if (hasNull && hasVal) return false
        return true;
      }
    },

    isDimAllowed() {
      if (this.selectedPackage) {
        if (["SOFTPACK", "PKG"].includes(this.selectedPackage)) return false;
        this.dimension.l = null;
        this.dimension.h = null;
        this.dimension.w = null;
        return true;
      }
      return false;
    },

    carrierRules: function () {
      return this.getCarrierRules(this.country || 'US');
    },

    serviceRules() {
      return this.carrierRules[this.selectedService] || [];
    },

    serviceOptions() {
      try {
        let options = Object.keys(this.carrierRules).map(serviceId => {
          return _.find(this.shipping_services, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(_.filter(options), "order");

        options = options.map(option => {
          let packageOptions = this.getPackageOptions(option.code);

          // Make sure at least 1 option exists
          if (!packageOptions.length) {
            return null;
          }

          return {
            value: option.code,
            text: option.name
          };
        });

        console.log('options', options);

        return _.filter(options);
      } catch (e) {
        return [];
      }
    },

    packageOptions() {
      if (
        _.isEmpty(this.selectedService) ||
        !this.serviceRules["parcelTypeRules"]
      ) {
        this.selectedPackage = '';
        return [];
      }

      return this.getPackageOptions(this.selectedService);
    },

    dimensionsPresetOptions() {
      let options = this.user.dimensions
        ? this.user.dimensions.map(dimension => {
          return {
            value: `${dimension.length}x${dimension.width}x${dimension.height}`,
            text: dimension.name
          };
        })
        : [];

      options = _.concat({
        value: '0x0x0',
        text: 'My Packaging',
      }, options);
      return options;
    },

    noWeight() {
      const { oz, lb } = this.weight;
      const isNull = [NaN, 0];
      if (isNull.includes(parseInt(oz)) && isNull.includes(parseInt(lb))) return true;
      return false;
    },

    insuranceOptions() {
      if (!this.user.shipsurance_terms) {
        return [];
      }

      // Domestic shipment. Just return static options
      // if (this.country === "US") {
      return [
        { value: 'none', text: 'None (Default Insurance)' },
        ...insurance.getSelectOptions()
      ]
      // }

      // International. Use shipping rules
      let rules = this.$store.getters.getInsuranceCarrierRules(
        this.order.shipping_service.code,
        this.order.package_type,
        this.shipping_address.country
      );
      const ruleOptions = rules.map(rule => {
        return {
          value: rule,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
  },

  mounted() {
    // this.showDefaultPackageDetails()
  },

  methods: {
    moment: moment,

    showSavePackageDetails() {
      const package_details = localStorage.getItem('package_details')
      console.log('Pacakge Details', package_details);
      if (package_details) {
        const p = JSON.parse(package_details)
        this.selectedService = p.selectedService
        this.selectedPackage = p.selectedPackage
        this.weight = p.weight
        this.dimension = p.dimension
      }
    },

    showDefaultPackageDetails() {
      if (this.user.default_package && this.user.package_detail_json) {
        const user_package = JSON.parse(this.user.package_detail_json)
        console.log('user_package', user_package);
        this.selectedService = user_package.selectedService
        this.selectedPackage = user_package.selectedPackage
        this.tmpMyPkg = user_package.tmpMyPkg || '0x0x0'
        this.weight = user_package.weight
        this.dimension = user_package.package
      }
    },

    getPackageOptions(serviceId) {
      // console.log("SERVICE ID", serviceId);
      let rules = this.$store.getters.getServicePackageRules(
        serviceId,
        this.country || 'US',
        true // filter inactive mail classes
      );

      // Flat Rates, this needs to be updated annually
      const flatRates = {
        EM: { // Priority Mail Express
          FRE: "$24.90",
          LGLFRENV: "$25.15",
          PFRENV: "$25.35"
        },
        PM: { // Priority Mail
          FRE: "$7.60", // Flat Rate Envelope
          SFRB: "$8.10", // Small Flat Rate Box
          LFRB: "$18.95", // Large Flat Rate Box
          LGLFRENV: "$7.90", // Legal Flat Rate Envelope
          FRB: "$14.00", // Medium Flat Rate Box
          MLFRB: "$18.35", // APO/FPO/DPO
          PFRENV: "$8.30" // Padded Flat Rate Envelope
        }
      }

      let options = serviceId
        ? rules.map(rule => {
          let name = rule.brandedName;

          if (
            serviceId in flatRates &&
            rule.parcelType in flatRates[serviceId]
          ) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }

          return {
            value: rule.parcelType,
            text: name
          };
        })
        : [];

      return options
      // return _.orderBy(options, "text");
    },

    onServiceClassChange(val) {
      this.selectedService = val;
      this.selectedPackage = 'PKG';

      switch (val) {
        case "FCPIS":
          if (!this.noWeight) {
            const total_weight = ((this.weight.lb || 0) * 16) + (this.weight.oz || 0);
            if (total_weight > 64) {
              this.error_msg = "Maximum weight limit for First-Class Package International is 4lbs.";
              this.weight = Object.assign({}, { lb: 0, oz: 0 });
            }
          }
          break;
        case "FCM":
          this.noLB = true;
          this.weight.lb = 0;
          break;
        default:
          this.noLB = false;
      }
      this.clear(false);
    },

    onPackagingSelected(val) {
      if (!val) return;
      const [l, w, h] = val.split('x');
      this.dimension = { l: parseInt(l), w: parseInt(w), h: parseInt(h) };
    },

    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },

    show({ ids, initialInsurance, initialRate, type }) {
      this.clear()

      if (type === 'LBLSBR') {
        console.log("SBR")
        this.showContinue = true;
        this.allGood = true;
        this.title = 'Scan-Based Return Label Details'
      }
      // console.log("initialRate: ", initialRate);
      // console.log("initialInsurance: ", initialInsurance);
      // console.log("raw ids length: ", ids.length);
      this.ids = ids.slice(0, 125);
      // console.log("ids: ", this.ids, this.ids.length);
      this.initialRate = this.totalRate = initialRate;
      this.initialInsurance = this.totalInsurance = initialInsurance;
      this.showSavePackageDetails()
      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    },

    save() {
      const package_details = JSON.stringify({
        selectedService: this.selectedService,
        selectedPackage: this.selectedPackage,
        weight: this.weight,
        dimension: this.dimension,
      })
      localStorage.setItem('package_details', package_details)

      const shippingService = this.getShippingService(this.selectedService);
      console.log("selected service: ", this.selectedService);
      console.log("shipping service", shippingService);

      this.$emit('save', {
        shipping_service_id: shippingService ? shippingService.id : null,
        package_type: shippingService ? this.selectedPackage : null,
        total_weight: parseInt(this.weight.lb || 0) * 16 + parseInt(this.weight.oz || 0),
        package_length: this.dimension.l,
        package_width: this.dimension.w,
        package_height: this.dimension.h,
      })
      this.hide()
      this.clear()
    },

    clearAll() {
      localStorage.removeItem('package_details')
      this.clear()
    },

    async calculateCost() {
      const ids = [...this.ids];
      const shippingService = this.getShippingService(this.selectedService);
      const returnDetail = {
        shipping_service_id: shippingService ? shippingService.id : null,
        package_type: shippingService ? this.selectedPackage : null,
        total_weight: parseInt(this.weight.lb || 0) * 16 + parseInt(this.weight.oz || 0),
        package_length: this.dimension.l,
        package_width: this.dimension.w,
        package_height: this.dimension.h,
      }

      // console.log("calculateCost")
      // console.log("ids: ", ids)
      // console.log("returnDetail: ", returnDetail);
      const base_url = process.env.MIX_INTEG_URL;
      this.calculating = true;
      try {
        const { data: { total_rates, errors } } = await axios.post(`${base_url}/check-returns`, {
          ids,
          returnDetail
        });

        console.log(this.balance);
        console.log("respnse total_rate: ", total_rates)
        console.log("respnse errors: ", errors)

        if (!errors) { // all good
          this.totalRate += parseFloat(total_rates);
          if (this.totalRate <= this.balance) {
            this.allGood = true;
            this.showContinue = true;
            this.calculating = false;
            this.insufficient = false;
          } else {
            this.allGood = false;
            this.showContinue = true;
            this.calculating = false;
            this.insufficient = true;
          }
        } else {
          this.allGood = false;
          this.showContinue = true;
          this.calculating = false;
          this.invalidServiceClass = true;
          console.error(errors);
        }
      } catch (e) {
        console.error(errors);
      }
    },


    clear(all = true) {
      if (all) {
        this.selectedService = ''
        this.selectedPackage = ''
        this.tmpMyPkg = '0x0x0'
        this.weight = { lb: null, oz: null }
        this.dimension = { l: null, w: null, h: null }
        this.noLB = false
      }

      this.title = 'Prepaid Return Label Details';
      this.allGood = false;
      this.showContinue = false;
      this.calculating = false;
      this.totalRate = this.initialRate;
      this.totalInsurance = this.initialInsurance;
      this.insufficient = false;
      this.invalidServiceClass = false;
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modals/PrepaidReturnModal.vue